__turbopack_context__.v({
  "fallbackNoticeWrapper": "_0mb2QG_fallbackNoticeWrapper",
  "fallbackServiceMessage": "_0mb2QG_fallbackServiceMessage",
  "noticeWrapper": "_0mb2QG_noticeWrapper",
  "notice__liYp8": "_0mb2QG_notice__liYp8",
  "notice__tNXy7": "_0mb2QG_notice__tNXy7",
  "serviceDataProvider": "_0mb2QG_serviceDataProvider",
});
